












































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { trim, dateFormat } from "@/util";
import Api from "../../../api/index";
import request from "../../../api/request";
import { getCookie } from "@szgc/plt-core-v2";
import LogTable from "../../../../../pt/components/LogTable/index.vue";
import { SzgcProcessGetor, SzgcMobileGetor } from "@/index";

@Component({
  name: "WbenchCopy",
  components: {
    LogTable,
    SzgcProcessGetor,
    SzgcMobileGetor
  }
})
export default class WbenchCopy extends Vue {
  @Prop({
    type: String,
    default: "web"
  })
  private client!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  private fileShow!: boolean;

  private businessName: any = "";
  private total: number = 0;
  private params: any = {
    current: 1,
    pageSize: 20
  };
  private tableData: any = [];
  private processShow: boolean = false;
  private processData: any = null;
  private logShow: boolean = false;
  private businessId: string | number = "";
  private prefix: string = "";

  mounted() {
    this.prefix = getCookie("plt-api-route") || "";
    this.getTableData();
  }

  /*获取表格数据*/
  async getTableData() {
    try {
      const { success, data, message } = await request({
        url: this.prefix + Api.getCopyPages,
        method: "post",
        data: {
          clientType: "web",
          businessName: trim(this.businessName),
          current: this.params.current,
          pageSize: this.params.pageSize
        }
      });
      if (!success) {
        this.$message.error("获取抄送事项列表失败: " + message);
        return false;
      }
      const temp: any = [];
      if (data && data.records && data.records.length > 0) {
        data.records.map((item: any) => {
          item.createTime = dateFormat(item.createTime);
          if (item.handleTime) {
            item.handleTime = dateFormat(item.handleTime);
          } else {
            item.handleTime = "--";
          }
          temp.push(item);
        });
        this.total = data.total;
      }
      this.tableData = temp;
    } catch (error: any) {
      this.$message.error("获取抄送事项列表失败: " + error);
    }
  }

  /*展示流程详情*/
  processModal(data: any) {
    if (!data.dialogEnable) {
      return this.$message.info("请在APP端查看和操作该事项");
    }
    this.processData = data;
    this.processShow = true;
  }

  /*展示流程日志*/
  flowLog(row: any) {
    this.businessId = row.businessId;
    this.logShow = true;
  }

  /*搜索*/
  searchEvt() {
    this.params.current = 1;
    this.params.businessId = "";
    this.getTableData();
  }

  /*页数改变*/
  onCurrentChange(val: any) {
    this.params.current = val;
    this.getTableData();
  }

  /*size改变*/
  onSizeChange(val: any) {
    this.params.current = 1;
    this.params.pageSize = val;
    this.getTableData();
  }
}
